import { render } from "./GameOver.vue?vue&type=template&id=2ecaa251&scoped=true"
import script from "./GameOver.vue?vue&type=script&lang=js"
export * from "./GameOver.vue?vue&type=script&lang=js"

import "./GameOver.vue?vue&type=style&index=0&id=2ecaa251&scoped=true&lang=css"

import exportComponent from "C:\\Data\\lightsOut\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ecaa251"]])

export default __exports__